import './App.css';
import React from 'react';
import Error from './client/Error.js';
import Offer from './client/offers/Offer.opportunity.js';
import OrganizationMain from './client/organization/Main.js';
import DashboardHome from './client/dashboard/home/Home.js';
import OrganizationUsers from './client/organization/Users.js';
import OpportunityTemplates from './client/dashboard/opportunitytemplates/OpportunityTemplates.js';
import OpportunityTemplatesBuilder from './client/dashboard/opportunitytemplates/OpportunityTemplatesBuilder.js';
import OpportunityEmailTemplateBuilder from './client/dashboard/opportunitytemplates/OpportunityEmailTemplateBuilder.js';
import OrganizationTerms from './client/organization/Terms.js';
import OrganizationHeaders from './client/organization/Headers.js';
import OrganizationSettings from './client/organization/Settings.js';
import OrganizationRates from './client/dashboard/rates/Rates.js';
import OrganizationRatesUpload from './client/dashboard/rates/RatesUpload.js';
import OrganizationRatesImport from './client/dashboard/rates/RatesImport.js';
import OrganizationRatesConvert from './client/dashboard/rates/RatesConvert.js';
import OrganizationStats from './client/organization/Stats.js';
import EmailPage from './client/dashboard/emailpage/EmailPage.js';
import FlowWelcome from './client/FlowWelcome.js';
import BookingsPage from './client/dashboard/bookings/BookingsPage.js';
import ResetPassword from './client/ResetPassword.js';
import AccountsMain from './client/dashboard/accounts/AccountsMain.js';
import TradelinePage from './client/dashboard/tradelines/TradelinePage.js';
import TradelinesPage from './client/dashboard/tradelines/TradelinesPage.js';
import TradelinesAnalytics from './client/dashboard/tradelines/TradelinesAnalytics.js';
import OpportunitiesTable from './client/dashboard/opportunitiestable/OpportunitiesTable.js';
import CampaignsMain from './client/CampaignsMain.js';
import CampaignsDetails from './client/CampaignsDetails.js';
import OpportunityRouter from './client/dashboard/opportunities/OpportunityRouter.js';
import QuotationsAnalytics from './client/dashboard/quotationsanalytics/QuotationsAnalytics.js';
import AutoPricing from './client/dashboard/autopricing/AutoPricing.js';
import AutoPricingMain from './client/dashboard/autopricing/AutoPricingMain.js';
import Elariom from './client/elariom/Elariom.js';
import AdminMain from './client/admin/Main.js';
import CompanyFeed from './client/dashboard/CompanyFeed/CompanyFeed.js';
import APIDocumentation from './client/APIDocumentation.js';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import AdminLocalDBResets from './client/admin/LocalDBResets.js';
import AdminSeaPortsPage from './client/admin/SeaPort.js';
import AdminAccountsSuppliers from './client/admin/AddAccounts.js';
import AdminFTPOrgUpdates from './client/admin/FTPOrgUpdates.js';
import AdminRestOrgUpdates from './client/admin/RestOrgUpdates.js';
import AdminCargofive from './client/admin/Cargofive.js';
import AdminCargofiveConverter from './client/admin/CargofiveConverter.js';
import AdminCreateOrganization from './client/admin/CreateOrganization.js';
import AdminErrorEmails from './client/admin/ErrorEmails.js';
import AdminReleases from './client/admin/Releases.js';
import AdminDeprecatedRates from './client/admin/DeprecatedRates.js';
import AdminHelpLogs from './client/admin/HelpLogs.js';
import AdminUsageReport from './client/admin/UsageReport.js';
import AdminRateImports from './client/admin/RateImports.js';
import AdminInquiryTraining from './client/admin/InquiryTraining.js';
import AdminLclTariffTiers from './client/admin/LclTariffTiers.js';
import AdminMetroTariff from './client/admin/MetroTariff.js';
import AdminSalesMachine from './client/admin/SalesMachine.js';
import SalesManagement from './client/dashboard/salesmanagement/SalesManagement.js';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="/organization/monada" replace />,
        errorElement: <Error />,
    },
    {
        path: '/error',
        element: <Error />,
    },
    {
        path: '/admin',
        element: <AdminMain />,
        errorElement: <Error />,
        children: [
            { path: 'local-db-resets', element: <AdminLocalDBResets /> },
            { path: 'sea-ports', element: <AdminSeaPortsPage /> },
            { path: 'accounts-suppliers', element: <AdminAccountsSuppliers /> },
            { path: 'ftp-org-updates', element: <AdminFTPOrgUpdates /> },
            { path: 'rest-org-updates', element: <AdminRestOrgUpdates /> },
            { path: 'cargo-five-monitoring', element: <AdminCargofive /> },
            { path: 'cargo-five-converter', element: <AdminCargofiveConverter /> },
            { path: 'lcl-tariff-tiers', element: <AdminLclTariffTiers /> },
            { path: 'metro-tariff', element: <AdminMetroTariff /> },
            { path: 'create-organization', element: <AdminCreateOrganization /> },
            { path: 'error-emails', element: <AdminErrorEmails /> },
            { path: 'releases', element: <AdminReleases /> },
            { path: 'deprecated-rates', element: <AdminDeprecatedRates /> },
            { path: 'help-logs', element: <AdminHelpLogs /> },
            { path: 'usage-report', element: <AdminUsageReport /> },
            { path: 'rate-imports', element: <AdminRateImports /> },
            { path: 'inquiry-training', element: <AdminInquiryTraining /> },
            { path: 'sales-machine', element: <AdminSalesMachine /> },
        ],
    },
    {
        path: '/api-documentation',
        element: <APIDocumentation />,
        errorElement: <Error />,
    },
    {
        path: '/organization/:orgId',
        element: <OrganizationMain />,
        errorElement: <Error />,
        children: [
            { index: true, element: <DashboardHome /> },
            { path: 'main', element: <Navigate to="../opportunities" replace /> },
            { path: 'opportunities', element: <FlowWelcome /> },
            { path: 'opportunities/:opportunityId', element: <OpportunityRouter /> },
            { path: 'bookings', element: <BookingsPage /> },
            { path: 'sales-management', element: <SalesManagement /> },
            { path: 'accounts', element: <AccountsMain mode='accounts' key='accounts' /> },
            { path: 'accounts/:accountId/details', element: <AccountsMain mode='accounts' /> },
            { path: 'accounts/:accountId/tradelines/:tradelineId', element: <AccountsMain mode='accounts' /> },
            { path: 'tradelines', element: <TradelinesPage /> },
            { path: 'tradelines/:tradelineId', element: <TradelinePage /> },
            { path: 'sales-performance', element: <TradelinesAnalytics /> },
            { path: 'opportunities-table', element: <OpportunitiesTable /> },
            { path: 'campaigns', element: <CampaignsMain /> },
            { path: 'campaigns/:id', element: <CampaignsDetails /> },
            { path: 'users', element: <OrganizationUsers /> },
            { path: 'suppliers', element: <AccountsMain mode='suppliers' key='suppliers' /> },
            { path: 'suppliers/:accountId/details', element: <AccountsMain mode='suppliers' /> },
            { path: 'forms', element: <OpportunityTemplates type='rate' /> },
            { path: 'forms/:id', element: <OpportunityTemplatesBuilder type='rate' /> },
            { path: 'templates', element: <OpportunityTemplates type='opportunity' /> },
            { path: 'templates/emails/:id', element: <OpportunityEmailTemplateBuilder type='opportunity' /> },
            { path: 'templates/:id', element: <OpportunityTemplatesBuilder type='opportunity' /> },
            { path: 'supplier-forms', element: <OpportunityTemplates type='rate' /> },
            { path: 'price-quote-forms', element: <OpportunityTemplates type='rate' /> },
            { path: 'terms', element: <OrganizationTerms /> },
            { path: 'headers', element: <OrganizationHeaders /> },
            { path: 'settings', element: <OrganizationSettings /> },
            { path: 'rates', element: <OrganizationRates mode={'rates'} /> },
            { path: 'rates/new', element: <OrganizationRates mode={'rates'} type={'new'} /> },
            { path: 'rates/clone/:rateId', element: <OrganizationRates mode={'rates'} type={'clone'} /> },
            { path: 'rates/:rateId', element: <OrganizationRates mode={'rates'} type={'edit'} /> },
            { path: 'rates/overlapping', element: <OrganizationRates mode={'rates'} type={'overlapping'} /> },
            { path: 'rates/upload', element: <OrganizationRatesUpload /> },
            { path: 'rates/import', element: <OrganizationRatesImport type={'new'} /> },
            { path: 'rates/import/log', element: <OrganizationRatesImport type={'log'} /> },
            { path: 'rates/convert', element: <OrganizationRatesConvert /> },
            { path: 'tariff', element: <OrganizationRates mode={'tariff'} /> },
            { path: 'tariff/new', element: <OrganizationRates mode={'tariff'} type={'new'} /> },
            { path: 'tariff/clone/:rateId', element: <OrganizationRates mode={'tariff'} type={'clone'} /> },
            { path: 'tariff/:rateId', element: <OrganizationRates mode={'tariff'} type={'edit'} /> },
            { path: 'stats', element: <OrganizationStats /> },
            { path: 'company-feed', element: <CompanyFeed /> },
            { path: 'quotation-analytics', element: <QuotationsAnalytics /> },
            { path: 'email', element: <EmailPage /> },
            { path: 'email/:emailId', element: <EmailPage /> },
            { path: 'auto-pricing/:autoPricingId', element: <AutoPricing /> },
            { path: 'auto-pricing', element: <AutoPricingMain /> },
            { path: 'elariom/*', element: <Elariom /> },
        ],
    },
    {
        path: '/offers',
        errorElement: <Error />,
        element: <Offer />,
    },
    {
        path: '/reset-password',
        errorElement: <Error />,
        element: <ResetPassword />,
    },
]);

function App() {
    return (
        <RouterProvider router={router} />
    );
}

export default App;
